import axios from 'axios';

// Strip whitespace, real newlines, AND literal "\n"/"\r" sequences from env
// values pasted with stray escapes (see services/api.ts for the full story).
const API_BASE_URL = (process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1')
  .replace(/(\\[rn])+$/g, '')
  .replace(/[\r\n\t\s]+$/g, '')
  .replace(/^\s+/g, '');

const demosClient = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 60000,
});

export interface DemoProjectSummary {
  id: number;
  file_name: string;
  project_type?: string;
  upload_date?: string;
  logline?: string | null;
  score?: number | null;
  format_type?: string;
  report_language?: string;
  generate_report?: number | boolean;
  generate_bible?: number | boolean;
  generate_character_breakdown?: number | boolean;
  generate_sequential_breakdown?: number | boolean;
  [key: string]: unknown;
}

export interface DemosListResponse {
  demos: DemoProjectSummary[];
  total: number;
}

export const demosService = {
  async getDemos(): Promise<DemosListResponse> {
    const { data } = await demosClient.get<DemosListResponse>('/demos');
    return data;
  },

  async getDemoProject(projectId: number): Promise<DemoProjectSummary> {
    const { data } = await demosClient.get<DemoProjectSummary>(`/demos/${projectId}`);
    return data;
  },

  async getDemoAnalysis(projectId: number) {
    const { data } = await demosClient.get(`/demos/${projectId}/analysis`);
    return data;
  },

  async getDemoCharacterBreakdown(projectId: number): Promise<{ project_id: number; breakdown_content: string | null }> {
    const { data } = await demosClient.get(`/demos/${projectId}/character-breakdown`);
    return data;
  },

  async getDemoSequentialBreakdown(projectId: number): Promise<{ project_id: number; tsv_content: string | null }> {
    const { data } = await demosClient.get(`/demos/${projectId}/sequential-breakdown`);
    return data;
  },
};
